import API from '../../services/API'
import {
    CEREMONY_ACTION_GET_CEREMONY,
    CEREMONY_ACTION_SAVE_CEREMONY,
    CEREMONY_GETTER,
    CEREMONY_MUTATION_ADD_CEREMONY_MUSICS,
    CEREMONY_MUTATION_ENTIRE_CEREMONY,
    CEREMONY_MUTATION_SINGLE_ENTRY
} from './ceremony-types'

import Vue from 'vue'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        ceremony: {}
    },

    getters: {
        [CEREMONY_GETTER]: state => state.ceremony
    },

    mutations: {
        [CEREMONY_MUTATION_SINGLE_ENTRY] (state, payload) {
            let key = Object.keys(payload)[0]
            Vue.set(state.ceremony, key, payload[key])
        },
        [CEREMONY_MUTATION_ENTIRE_CEREMONY] (state, payload) { state.ceremony = payload },
        [CEREMONY_MUTATION_ADD_CEREMONY_MUSICS] (state, payload) { state.ceremony.ceremony_musics.push(payload) }
    },

    actions: {
        [CEREMONY_ACTION_GET_CEREMONY] ({commit}) {
            API.loadCeremony()
                .then((ceremonyData) => { commit(CEREMONY_MUTATION_ENTIRE_CEREMONY, ceremonyData) })
                .catch((error) => console.log('' + error.message))
        },
        [CEREMONY_ACTION_SAVE_CEREMONY] ({commit, state}, payload) {
            API.saveCeremony(payload)
                .then((ceremonyData) => {
                    OAlert.showSuccess('', i18n.t('feedback.ceremonySucSave'))
                    commit(CEREMONY_MUTATION_ENTIRE_CEREMONY, ceremonyData)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/ceremony.js